import AddressSearch from 'components/addressSearch/AddressSearch';
import { useSelector, useDispatch } from 'react-redux';
import { usePageTitle } from 'utils/pageTitle';


import { openModal } from 'reducers/modalReducer';
import { MODAL_TYPES } from 'view/ModalManager';

import './PropertyNotFound.css';


const nycCityNames = [
	'New York, NY',
	'Brooklyn, NY',
	'Staten Island, NY',
	'Bronx, NY',
	'The Bronx, NY',
	'Manhattan, NY',
	'Queens, NY',
];

const FORM_TYPES = {
	OUTSIDE_NYC: 'Outside NYC',
	NOT_FOUND: 'Not Found',
}

const isAddressInNYC = (address) => {
	let ret = false;
	nycCityNames.forEach(cityName => {
		if (address.includes(cityName)) {
			ret = true;
		}
	});
	return ret;
};

const PropertyNotFound = (props) => {
	const dispatch = useDispatch();
	usePageTitle('Not Found');
	const {
		query,
	} = useSelector(state => ({
		query: state.router.location?.query,
	}));
	let address = decodeURIComponent(query?.address);

	const openMissingPropertyModal = () => {
		let isInNYC = isAddressInNYC(address);
		let type = FORM_TYPES.NOT_FOUND;
		if (!isInNYC) {
			type = FORM_TYPES.OUTSIDE_NYC;
		}
		dispatch(openModal(MODAL_TYPES.MISSING_PROPERTY_REPORT, { missingAddress: address, type }))
	}

	return (
		<div className="property-not-found-page">
			<div className="property-not-found-card">
				<div className="property-not-found-icon" aria-hidden="true">
					<i className="bi bi-search" />
				</div>

				<h1 className="property-not-found-title">
					We couldn&apos;t find that property
				</h1>
				{query?.address && (
					<div className="property-not-found-address" title={address}>
						<i className="bi bi-geo-alt" aria-hidden="true" />
						<span>{address}</span>
					</div>
				)}
				<p className="property-not-found-text">
					Check the spelling, or search by block and lot instead.
				</p>

				<div className="address-search-wrapper">
					<AddressSearch
						addressSearchLabel="Search by address"
						blockAndLotSearchLabel="Search by block and lot"
					/>
				</div>

				<div className="property-not-found-footer">
					<span>Still can&apos;t find it?</span>
					<button className="property-not-found-report-btn" onClick={openMissingPropertyModal}>
						<i className="bi bi-flag" aria-hidden="true" />
						Report missing property
					</button>
				</div>
			</div>
		</div>
	);
};

export default PropertyNotFound;
